import axios from "axios"

export const handleFormatToBoolean = (value) => value && !!value.includes("yes")
export const handleFormatToArrayOfString = (value) => (value ? value.map(({ value }) => value) : [])

export const CLAIMS_EXCEL_URL =
  "https://proquinal-my.sharepoint.com/:x:/r/personal/juand_coronado_spradling_group/_layouts/15/Doc.aspx?sourcedoc=%7B339F98FE-2E45-4641-BEE2-D267D3F1DCD4%7D&file=Claims.xlsx&action=default&mobileredirect=true"

const URL_ENDPOIND_PAYROLL = process.env.REACT_APP_SERVER_ENDPOIND_PAYROLL_CLAIMS

export const handleSendClaimToPayroll = async ({ data, callback, extraInformation }) => {
  try {
    const combinedData = { ...data, ...extraInformation }

    const { data: { claim_id: resultClaimNominaId } } = await axios.post(
      URL_ENDPOIND_PAYROLL,
      JSON.stringify(combinedData),
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    )

    // New data with claim nomina ID to show in Thank you page
    const dataWithClaimNominaId = { ...data, claimNominaId: resultClaimNominaId }
    if (resultClaimNominaId) callback(dataWithClaimNominaId)

    return resultClaimNominaId
  } catch (e) {
    console.log("handleSendClaimToPayroll error: ", e)
  }
}
